// 这个JS文件就是专门用于管理请求各种接口地址的
import Net from './net'

// 封装各种接口请求
export const getBannerleft = () => Net.get('/f/eshopping/eshoppingModeAndProduct/indexpicture');
// export const getBannerleft = () => request.get('/f/eshopping/eshoppingModeAndProduct/indexpicture',data);
//export const getBannerright = () => request.get('banner?type=2');
